<mat-menu #menu="matMenu">
    <button
        mat-menu-item
        (click)="eligibilityChange.emit(ClientEligibilityStatus.Pending)">
        {{ 'az.clients.clientDetail.eligibility.pending' | translate }}
    </button>
    <button
        mat-menu-item
        (click)="eligibilityChange.emit(ClientEligibilityStatus.Eligible)">
        {{ 'az.clients.clientDetail.eligibility.eligible' | translate }}
    </button>
    <button
        mat-menu-item
        (click)="eligibilityChange.emit(ClientEligibilityStatus.NotEligible)">
        {{ 'az.clients.clientDetail.eligibility.notEligible' | translate }}
    </button>
</mat-menu>
